import { cloneConfig, linesFromText, numberFromInput, validateOfferEditor } from './commonEditorModel';
import { serializeDisplayChipList } from '../fields/displayMetadata';

export const tvPvrModes = [
    { value: 'included', label: 'Included' },
    { value: 'optional', label: 'Optional' },
    { value: 'none', label: 'None' }
];

export const validateTvDisplayEditor = (values = {}) => {
    const errors = validateOfferEditor({
        ...values,
        displayName: values.displayNameOverride || values.packageKey,
        emailBulletsText: values.customerEmailBulletsText
    }, {
        priceFields: ['pvrPrice', 'emailRegularReferencePrice']
    });
    if (!tvPvrModes.some((mode) => mode.value === values.pvrMode)) {
        errors.push('PVR behavior must be Included, Optional, or None.');
    }
    return errors;
};

export const serializeTvDisplayEditor = (sourceConfig, editor) => {
    const nextConfig = cloneConfig(sourceConfig);
    const packages = nextConfig.tvDisplaySettings?.packages || [];
    const index = packages.findIndex((pkg) => pkg.packageKey === editor.packageKey);
    if (index === -1) {
        throw new Error('Unable to find the selected TV display settings row in the draft config.');
    }

    const values = editor.values;
    const topBadges = serializeDisplayChipList(values.topBadges);
    const detailChips = serializeDisplayChipList(values.displayChips);
    packages[index] = {
        ...packages[index],
        packageKey: editor.packageKey,
        displayNameOverride: values.displayNameOverride.trim(),
        cardDescription: values.cardDescription.trim(),
        quoteSummaryNote: values.quoteSummaryNote.trim(),
        customerEmailName: values.customerEmailName.trim(),
        customerEmailBullets: linesFromText(values.customerEmailBulletsText),
        pvrMode: values.pvrMode,
        pvrPrice: numberFromInput(values.pvrPrice),
        topBadges,
        cardBadges: topBadges,
        detailChips,
        featureChips: detailChips,
        chips: detailChips,
        visibleInManualFallback: Boolean(values.visibleInManualFallback),
        visibleInAgentBuilder: Boolean(values.visibleInAgentBuilder),
        visibleInAdminBuilder: Boolean(values.visibleInAdminBuilder),
        sortOrder: Number(values.sortOrder),
        internalAgentNote: values.internalAgentNote.trim(),
        customerEmailEligible: Boolean(values.customerEmailEligible),
        emailRegularReferencePrice: values.emailRegularReferencePrice === ''
            ? undefined
            : numberFromInput(values.emailRegularReferencePrice)
    };
    nextConfig.tvDisplaySettings = {
        ...(nextConfig.tvDisplaySettings || {}),
        packages
    };
    return nextConfig;
};
